import { QrCodeLinkCreatorService } from 'client/js/main/services/QrCodeLinkCreatorService/QrCodeLinkCreatorService';
import dash_api from 'client/js/main/support/dash_api';
import { selectQrCodeSettings } from 'client/js/redux/domains/AppStore';
import {
  areQrCodeSettingsEqual,
  selectQrCodeLinkCreatorState,
} from 'client/js/redux/domains/QrCodeLinkCreator/QrCodeLinkCreator.selectors';
import type { DataAction } from 'client/js/redux/types/dataAction.type';
import type { Dispatch, RootState } from 'client/js/redux/types/redux.types';
import type { IQrCodeLink, IQrCodeLinkCreate, IQrCodeLinkUpdate } from '../../../../../../shared/types';
import { deepCopy } from '../../../../../../shared/utils';

const SUBMIT_QR_CODE_LINK_URL = '/v1/qr-code-link';

export const SUBMIT_QR_CODE_LINK = 'SUBMIT_QR_CODE_LINK' as const;

export const submitQrCodeLink =
  () =>
  async (_: Dispatch, getState: () => RootState): Promise<IQrCodeLink> => {
    const state = getState();
    const qrCodeState = deepCopy(selectQrCodeLinkCreatorState(state));
    const qrCodeSettings = selectQrCodeSettings(state);

    const areQrCodeSettingsUnchanged = areQrCodeSettingsEqual(qrCodeState.qrCodeCustomization, qrCodeSettings);
    if (areQrCodeSettingsUnchanged) {
      qrCodeState.qrCodeCustomization = {};
    }

    const payload: IQrCodeLinkCreate | IQrCodeLinkUpdate = QrCodeLinkCreatorService.getQrCodeLinkPayload(qrCodeState);

    let response;
    if (payload.id) {
      response = await dash_api.put(`${SUBMIT_QR_CODE_LINK_URL}/${payload.id}`, payload);
    } else {
      response = await dash_api.post(SUBMIT_QR_CODE_LINK_URL, payload);
    }

    return response?.data;
  };

export type SubmitQrCodeLinkAction = DataAction<typeof SUBMIT_QR_CODE_LINK, void>;
